module.exports = __webpack_public_path__ + "static/media/Refund_Policy.d04d60a5.pdf";